import React from 'react';
import anime from 'animejs';

import './home.css';

const content = {
  header: "Hello my name is Joe! I'm a experienced Frontend/ Fullstack Developer of web applications.",
  body: "I create scalable web experiences for my users with quality and integrity in mind.",
}

const Home = () => (
  <>
    <div className="container">
      <div className="content-wrapper">
        <div>
          <h1 className="home-title" style={{ opacity: 0 }} ref={(ref) => {
            anime({
              targets: ref,
              delay: 4000,
              opacity: 1,
              duration: 1000,
              easing: 'easeInOutSine'
            })
          }} >
            <span className="header">{content.header}</span>
            <span className="sub-content">
              {content.body}
            </span>
          </h1>
        </div>
      </div>
    </div>
  </>
)


export default Home;
